import React from "react";
import QPhototModuleSubtopic from "../../../QPhotoModuleSubtopic";

const ApplicationInAnalyticFunction = () => (
  <QPhototModuleSubtopic
    title="Application in analytic function"
    videos={[
      "https://www.youtube.com/embed/yLb9tjUXifk",
      "https://www.youtube.com/embed/d6DSwiVj6Ls"
    ]}
    takeaways={[]}
    questions={[
        {image:"/cvla_7.png"},
        {image:"/cvla_8.png"},
        {image:"/cvla_9.png"},
        {image:"/cvla_10.png"},
        
    ]}
    exampleVideos={[]}
  />
);

export default ApplicationInAnalyticFunction;
